import axios from 'axios'
import store from '@/store'
// import { AUTH_SUCCESS } from '@/store/auth/mutations'

const apiCall = axios.create({
  baseURL: 'https://api.evangelie.life/'
})

apiCall.interceptors.request.use((config) => {
  if (store.state.AuthModule.token) {
    config.headers.common['X-AUTH-TOKEN'] = store.state.AuthModule.token
  }
  if (store.state.UserModule.locale) {
    config.headers.common['Accept-Language'] = store.state.UserModule.locale
  }
  return config
})
apiCall.interceptors.response.use((response) => {
  // if (response.data.token) {
  //   store.commit('AuthModule/' + AUTH_SUCCESS, response.data.token)
  // }
  return response.data
}, (error) => {
  const { response: { status, data } } = error

  if (error instanceof Error) {
    store.dispatch('AuthModule/logout')
    throw new Error(error.response.data.message || 'error_occurred')
  }

  if ([401, 403].some((code) => {
    return status === code
  })) {
    store.dispatch('AuthModule/logout')
  }

  throw new Error(data.message || 'Произошла ошибка!')
})

const objectToFormData = function (obj, form, namespace) {
  let fd = form || new FormData()
  let formKey

  for (let property in obj) {
    if (obj.hasOwnProperty(property)) {
      if (namespace) {
        formKey = namespace + '[' + property + ']'
      } else {
        formKey = property
      }

      if ((obj[property] instanceof FormData)) {
        for (let key of obj[property].keys()) {
          objectToFormData(obj[property].getAll(key), fd, formKey + '[' + key + ']')
        }
      } else {
        if (typeof obj[property] === 'object' && !(obj[property] instanceof File) && !(obj[property] instanceof Blob)) {
          objectToFormData(obj[property], fd, formKey)
        } else {
          fd.append(formKey, obj[property])
        }
      }
    }
  }

  return fd
}

const rpc = async ({ method, url, data, params }) => {
  params = params || {}
  Object.keys(params).map((key) => {
    const value = params[key]
    let re = new RegExp('{' + key + '}', 'g')
    if (url.match(re)) {
      url = url.replace(re, value)
      delete params[key]
    }
  })

  data = data || {}
  data = objectToFormData(data)

  try {
    return await apiCall({ method, url, data, params })
  } catch (error) {
    throw new Error(error.message)
  }
}

export default rpc
